import { CONSENT_STORAGE_KEY, parseStoredConsent } from '@/services/consentRecord'
import type { StoredConsent } from '@/types/consent'

// localStorage can throw (Safari private mode, blocked site data, quota). The
// banner must keep working without it: the decision then lives in memory for
// the visit and the banner asks again on the next load, which is the safe
// failure (never "assume granted").

export function loadConsent(): StoredConsent | null {
  try {
    return parseStoredConsent(localStorage.getItem(CONSENT_STORAGE_KEY))
  } catch {
    return null
  }
}

export function persistConsent(record: StoredConsent): boolean {
  try {
    localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(record))
    return true
  } catch {
    return false
  }
}
